import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class TheCryptGameAssets {

    public static INTRO_BACKGROUND: string = "introBg";
    public static INTRO_LOGO: string = "introLogo";

    public static NORMAL_REEL_DIVIDER: string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER: string = "reelDividerNearWin";

    public static MAIN_GAME_BACKGROUND: string = "introBg";
    public static FREE_SPIN_BACKGROUND: string = "freespinBackground";

    public static FREE_SPIN_INTRO_PATTERN: string = "fsPattern";
    public static BITMAP_FONT_WIN_COUNT_UP: string = "NumbersWinCountUp";
    public static BITMAP_FONT_WIN_WAYS: string = "NumbersWaysWon";
    public static BITMAP_FONT_NUDGE_WILD_MULTIPLIER: string = "NumbersXNudge";
    public static BITMAP_FONT_METER_M1: string = "NumbersM1Mult";
    public static BITMAP_FONT_FS_SPINS: string = "NumbersFSSpins";


    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],
        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("NumbersM1Mult", "fonts/bitmapfonts/NumbersM1Mult.fnt"),
                    new BitmapFontAsset("NumbersWaysWon", "fonts/bitmapfonts/NumbersWaysWon.fnt"),
                    new BitmapFontAsset("NumbersXNudge", "fonts/bitmapfonts/NumbersXNudge.fnt"),
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("NumbersFSSpins", "fonts/bitmapfonts/NumbersFSSpins.fnt")
                ]
            },
            //{
            //    name: "backgrounds",
            //    assets: [
            //        new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json")
            //    ],
            //    animations: {
            //        "mainBackground": "mainBackground",
            //    }
            //},
            {
                name: "main",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json")
                ]
            },
            {
                name: "mainHigh",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
		            new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json")
                    
                ],
                animations: {
                    "gemAdd": "gem_add/FS_gem_add_",
                }
            },
            {
                name: "symbolsHighQuality",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsHighQuality0", "sheets/symbolsHighQuality/symbolsHighQuality0.json"),
                    new TextureAsset("symbolsHighQuality1", "sheets/symbolsHighQuality/symbolsHighQuality1.json")
                ],
                animations: {
                    "symFrame": "symFrame",
                    "M/M_spin": "XW/XW_spin",
                    "symFrame_FW": "symFrame_FW"
                }
            },
            {
                name: "noTinyPng",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("noTinyPng", "sheets/noTinyPng/noTinyPng0.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("W_1", "spine/W_1.json"),
                    new SpineAsset("W_2", "spine/W_2.json"),
                    new SpineAsset("W_3", "spine/W_3.json"),
                    new SpineAsset("M", "spine/XW.json"),
                    new SpineAsset("meterM1", "spine/meterM1.json"),
                    new SpineAsset("S_1", "spine/S_1.json"),
                    new SpineAsset("S_2", "spine/S_2.json"),
                    new SpineAsset("S_3", "spine/S_3.json"),
                    new SpineAsset("SymLSize1", "spine/symL_1.json"),
                    new SpineAsset("SymLSize2", "spine/symL_2.json"),
                    new SpineAsset("SymLSize3", "spine/symL_3.json"),
                    new SpineAsset("SymMSize1", "spine/symM_1.json"),
                    new SpineAsset("SymMSize2", "spine/symM_2.json"),
                    new SpineAsset("SymMSize3", "spine/symM_3.json"),
                    new SpineAsset("reelFrame", "spine/reel_frame.json"),
                    new SpineAsset("reelBg", "spine/reel_bg.json"),
                    new SpineAsset("meter", "spine/meter.json"),
                    new SpineAsset("FW", "spine/stacked_wild.json"),
                    new SpineAsset("FS_background", "spine/FS_background.json"),
                    new SpineAsset("FS_Intro", "spine/FS_Intro.json"),
                    new SpineAsset("FS_Outro", "spine/FS_Outro.json"),
                    new SpineAsset("bigWinLv1", "spine/bigWinLv1.json"),
                    new SpineAsset("bigWinLv2", "spine/bigWinLv2.json"),
                    new SpineAsset("bigWinLv3", "spine/bigWinLv3.json"),
                    new SpineAsset("bigWinLv4", "spine/bigWinLv4.json"),
                    new SpineAsset("bigWinLv5", "spine/bigWinLv5.json"),
                    new SpineAsset("winCap", "spine/winCap.json"),
                    new SpineAsset("plus2banner", "spine/plus2banner.json"),
                    new SpineAsset("total_win", "spine/total_win.json"),
                    new SpineAsset("s_anticipation", "spine/s_anticipation.json"),
                    new SpineAsset("eyeAnimation", "spine/eye.json"),
                    new SpineAsset("ghost", "spine/ghost.json"),
                ]
            }

        ]
    };
}
